import { useQuery } from "@tanstack/react-query";
import { fetchAiHiringPlanStatus } from "../utils/api";

const DEFAULT_PLAN_STATUS = {
  planActive: false,
  planType: null,
  purchasedAt: null,
};

export const useAIHiringPlan = (locationId) => {
  const query = useQuery({
    queryKey: ["ai-hiring-plan-status", String(locationId || "agency")],
    queryFn: async () => {
      const data = await fetchAiHiringPlanStatus(locationId);
      return {
        planActive: Boolean(data?.planActive),
        planType: data?.planType || null,
        purchasedAt: data?.purchasedAt || null,
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    enabled: Boolean(localStorage.getItem("token")),
  });

  const plan = query.data || DEFAULT_PLAN_STATUS;
  return {
    planActive: Boolean(plan.planActive),
    planType: plan.planType,
    purchasedAt: plan.purchasedAt,
    isLoading: query.isLoading,
  };
};

export default useAIHiringPlan;
